
import { Parser } from "htmlparser2";
export default {
    spacingDebug: true,
    components: {
        HeaderTemplate: () => import("~/components/global/templates/HeaderTemplate"),
    },
    props: {
        item: { type: Object, required: true },
        featured: { type: Boolean, default: false },
        compact: { type: Boolean, default: false },
    },
    computed: {
        cardSubheader() {
            return [this.dateLabel, this.isFeatured ? "(Featured)" : ""].filter(Boolean).join(" ");
        },
        image() {
            const images = Array.isArray(this.item.images) ? this.item.images : [];
            const image = images.find((image) => image?.path);
            return {
                index: this.getRandom4DigitString(),
                src: image?.path || "/assets/defaults/mico-thumbnail-[light].webp",
                alt: image?.alt || this.item.title,
            };
        },
        excerpt() {
            const candidates = this.featured ? [this.item.content, this.item.description] : [this.item.description, this.item.content];
            return candidates.map(this.plainText).find((text) => text.length) || "";
        },
        dateLabel() {
            if (!this.item.published_at) return "";
            const date = this.$moment(this.item.published_at);
            return date.isValid() ? date.format("MMM D, YYYY") : "";
        },
        isFeatured() {
            return [true, 1, "1"].includes(this.item.is_featured);
        },
    },
    methods: {
        plainText(content) {
            if (typeof content !== "string") return "";
            let text = "";
            let hidden = false;
            const parser = new Parser(
                {
                    onopentag(name) {
                        if (name === "script" || name === "style") hidden = true;
                        if (name === "br") text += " ";
                    },
                    ontext(value) {
                        if (!hidden) text += value;
                    },
                    onclosetag(name) {
                        if (name === "script" || name === "style") hidden = false;
                        if (["p", "div", "li", "h1", "h2", "h3"].includes(name)) text += " ";
                    },
                },
                { decodeEntities: true },
            );
            parser.end(content);
            return text.replace(/\s+/g, " ").trim();
        },
        getRandom4DigitString() {
            return Math.floor(Math.random() * 10000)
                .toString()
                .padStart(4, "0");
        },
    },
};
